/* GENERATED FILE */
import  { useContext  } from "solid-js";
import { IconContext } from "../lib";

const renderPathFor = (weight: string, color: string) => {
  switch (weight) {
    case "bold":
      return (
        <>
          <rect x="23.13" y="69.13" width="53.74" height="53.74" transform="translate(-53.24 63.47) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/><rect x="99.72" y="67.72" width="56.57" height="56.57" transform="translate(-30.39 118.63) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/><rect x="99.72" y="147.72" width="56.57" height="56.57" transform="translate(-86.96 142.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/><rect x="179.13" y="69.13" width="53.74" height="53.74" transform="translate(-7.55 173.78) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/>
        </>
      )
    case "duotone":
      return (
        <>
          <rect x="19.72" y="67.72" width="56.57" height="56.57" transform="translate(-53.82 62.06) rotate(-45)" opacity="0.2"/><rect x="99.72" y="67.72" width="56.57" height="56.57" transform="translate(-30.39 118.63) rotate(-45)" opacity="0.2"/><rect x="99.72" y="147.72" width="56.57" height="56.57" transform="translate(-86.96 142.06) rotate(-45)" opacity="0.2"/><rect x="179.72" y="67.72" width="56.57" height="56.57" transform="translate(-6.96 175.2) rotate(-45)" opacity="0.2"/><rect x="19.72" y="67.72" width="56.57" height="56.57" transform="translate(-53.82 62.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="99.72" y="67.72" width="56.57" height="56.57" transform="translate(-30.39 118.63) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="99.72" y="147.72" width="56.57" height="56.57" transform="translate(-86.96 142.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="179.72" y="67.72" width="56.57" height="56.57" transform="translate(-6.96 175.2) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
        </>
      )
    case "fill":
      return (
        <>
          <path d="M253.66,101.66l-36,36a8,8,0,0,1-11.32,0l-36-36-.34-.38-.34.38L135.31,136l34.35,34.34a8,8,0,0,1,0,11.32l-36,36a8,8,0,0,1-11.32,0l-36-36a8,8,0,0,1,0-11.32L120.69,136,86.34,101.66l-.34-.38-.34.38-36,36a8,8,0,0,1-11.32,0l-36-36a8,8,0,0,1,0-11.32l36-36a8,8,0,0,1,11.32,0l36,36,.34.38.34-.38,36-36a8,8,0,0,1,11.32,0l36,36,.34.38.34-.38,36-36a8,8,0,0,1,11.32,0l36,36A8,8,0,0,1,253.66,101.66Z"/>
        </>
      )
    case "light":
      return (
        <>
          <rect x="19.72" y="67.72" width="56.57" height="56.57" transform="translate(-53.82 62.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><rect x="99.72" y="67.72" width="56.57" height="56.57" transform="translate(-30.39 118.63) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><rect x="99.72" y="147.72" width="56.57" height="56.57" transform="translate(-86.96 142.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><rect x="179.72" y="67.72" width="56.57" height="56.57" transform="translate(-6.96 175.2) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/>
        </>
      )
    case "thin":
      return (
        <>
          <rect x="19.72" y="67.72" width="56.57" height="56.57" transform="translate(-53.82 62.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect x="99.72" y="67.72" width="56.57" height="56.57" transform="translate(-30.39 118.63) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect x="99.72" y="147.72" width="56.57" height="56.57" transform="translate(-86.96 142.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect x="179.72" y="67.72" width="56.57" height="56.57" transform="translate(-6.96 175.2) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/>
        </>
      )
    case "regular":
      return (
        <>
          <rect x="19.72" y="67.72" width="56.57" height="56.57" transform="translate(-53.82 62.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="99.72" y="67.72" width="56.57" height="56.57" transform="translate(-30.39 118.63) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="99.72" y="147.72" width="56.57" height="56.57" transform="translate(-86.96 142.06) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="179.72" y="67.72" width="56.57" height="56.57" transform="translate(-6.96 175.2) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
        </>
      )
    default:
      console.error(
        'Unsupported icon weight. Choose from "thin", "light", "regular", "bold", "fill", or "duotone".'
      );
      return null;
  }
};

const TidalLogo = (props: any, ref: any)  => {
  const { color, size, weight, mirrored, children, ...restProps } = props;
  const {
    color: contextColor,
    size: contextSize,
    weight: contextWeight,
    mirrored: contextMirrored,
    ...restContext
  } = useContext(IconContext);

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? contextSize}
      height={size ?? contextSize}
      fill={color ?? contextColor}
      viewBox="0 0 256 256"
      transform={mirrored || contextMirrored ? "scale(-1, 1)" : undefined}
      {...restContext}
      {...restProps}
    >
      {children}
      <rect width="256" height="256" fill="none"/>
      {renderPathFor(weight ?? contextWeight, color ?? contextColor)}
    </svg>
  );
};


export default TidalLogo;
